import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { getSelectedFilters } from '../store/selectors/package-visualizer.selectors';
import { Observable } from 'rxjs/Observable';
import { filter, first } from 'rxjs/operators';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'biz-package-visualizer-filters',
  templateUrl: './package-visualizer-filters.component.html',
  styleUrls: ['./package-visualizer-filters.component.scss']
})

export class PackageVisualizerFiltersComponent implements OnInit {

  @Output() onFilterOptionsChange = new EventEmitter<Array<string>>();

  public filters: Array<string>;
  public filterOptions = Array<IPackageFilterOption>();
  public isAllSelected = false;


  private get selectedFilters() : Array<string> {
    const selectedOptions = new Array<string>();
    _.forEach(this.filterOptions, (option) => {
      if(option.selected) {
        selectedOptions.push(option.name);
      }
    });
    return selectedOptions;
  }


  constructor(private _store: Store<IAppState>) {
    this.filterOptions = [
      { name: 'Entity', textKey: 'DEPLOYMENT.ENTITIES', selected: false },
      { name: 'Attribute', textKey: 'DEPLOYMENT.ATTRIBUTES', selected: false },
      { name: 'Rule', textKey: 'DEPLOYMENT.RULES', selected: false },
      { name: 'VirtualCollection', textKey: 'DEPLOYMENT.COLLECTIONS', selected: false },
      { name: 'DocumentTemplate', textKey: 'DEPLOYMENT.DOCUMENTS_TEMPLATES', selected: false },
      { name: 'UserProperty', textKey: 'DEPLOYMENT.USER_PROPERTIES', selected: false },
      { name: 'Process', textKey: 'DEPLOYMENT.PROCESSES', selected: false },
      { name: 'Form', textKey: 'DEPLOYMENT.FORMS', selected: false }
    ];

    this._store.pipe(select(getSelectedFilters), first()).subscribe(filters => {
      this.filters = filters;
    })
  }

  ngOnInit(): void {
    this.loadFilters();
  }

  loadFilters(){
    _.forEach(this.filters, (option) =>
      {
          const filterFind = _.find(this.filterOptions, {name: option});
          filterFind.selected = true;
      });
  }

  onCheckedChange(event: boolean) {
    if (typeof (event) === 'boolean') {
      if(this.isAllSelected && !event) {
        this.isAllSelected = false;
      }

      this.onFilterOptionsChange.emit(this.selectedFilters)
    }
  }

  onSelectAllChange(event: boolean) {
    if (typeof (event) === 'boolean') {
      this.isAllSelected = event;
      _.forEach(this.filterOptions, (option) =>
      {
        option.selected = event;
      });
    }
  }

  public onSelectAll() {
    this.isAllSelected = !this.isAllSelected;
    _.forEach(this.filterOptions, (option) =>
    {
      option.selected = this.isAllSelected;
    });
    this.onFilterOptionsChange.emit(this.selectedFilters)
  }
}
